<template>
  <div class="container">
    <div class="">
      <b-navbar :shadow="true">
          <template slot="brand">
              <b-navbar-item tag="router-link" :to="{ path: '/' }">
                  <span style="color: #237DDA;font-weight: bolder;">
                    <b>Metatext Admin</b>
                  </span>
              </b-navbar-item>
          </template>
          <template slot="start">
              <b-navbar-item tag="router-link" :to="{ path: '/explore' }">
                Explore
              </b-navbar-item>
              <b-navbar-item tag="router-link" :to="{ path: '/settings' }">
                  Settings
              </b-navbar-item>
              <b-navbar-dropdown label="Info">
                  <b-navbar-item tag="router-link" :to="{ path: '/' }">
                      About
                  </b-navbar-item>
                  <b-navbar-item tag="router-link" :to="{ path: '/' }">
                      Contact
                  </b-navbar-item>
              </b-navbar-dropdown>
              <b-navbar-dropdown label="Admin">
                  <b-navbar-item tag="router-link" :to="{ path: '/admin/blog' }">
                      Blog
                  </b-navbar-item>
                  <b-navbar-item tag="router-link" :to="{ path: '/admin' }">
                      Users
                  </b-navbar-item>
              </b-navbar-dropdown>
          </template>

          <template slot="end">
              <b-navbar-item tag="div">
                  <div class="buttons">
                      <a class="button is-secondary" @click="signOut">
                          <strong>
                          Sign out
                          </strong>
                      </a>
                      <!--a class="button is-light">
                          Log in
                      </a-->
                  </div>
              </b-navbar-item>
          </template>
      </b-navbar>
    </div>
    <br>
    
    <router-view id="content" />
    
    <div v-if="modal" id="modal-mask">
      <div class="modal-container">
        <component :is="modal.component" v-bind="modal.data"></component>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  computed: {
  },
  methods: {
    async signOut() {
      await this.$auth.signOut();
      window.location.replace("/");
    }
  }
};
</script>

<style lang="scss" scoped>
#home {
  #header {
    padding: 16px 64px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-bottom: solid 1px #e6e4e4;

    #app-logo {
      text-transform: uppercase;
      font-size: 1.5em;
      cursor: pointer;

      &:hover {
        color: #42b983;
      }
    }
    #nav {
      a {
        font-weight: bold;
        color: #2c3e50;

        &:not(:last-child) {
          margin-right: 8px;
        }

        &.router-link-exact-active {
          color: #42b983;
        }
      }
    }
  }

  #content {
    padding: 20px 64px;
  }

  #modal-mask {
    width: 100%;
    height: 100%;
    position: fixed;
    background: rgba($color: #000000, $alpha: 0.6);
    top: 0;
    left: 0;

    .modal-container {
      background: white;
      width: 500px;
      border-radius: 4px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>
